const configByLanguage = {
  'pt-br': {
    country: 'br',
    domain: 'www.nationalgeographicbrasil.com',
    html: {
      stage: 'd2g8e43tkaq8j0.cloudfront.net'
    },
    static: {
      prod: 'static.nationalgeographicbrasil.com'
      // stage: 'd2w3k52cqa70kn.cloudfront.net'
    },
    search: {
      // prod is always `https://${configData.canonicalDomain}/api-pluto/pluto`
      stage: 'gvu8h7t1oc'
    },
    weekStartDay: 0,
    region: 'latam',
    currency: 'brl'
  },
  'es-mx': {
    country: 'mx',
    domain: 'www.nationalgeographicla.com',
    html: {
      stage: 'd10tqlaqrqekdp.cloudfront.net'
    },
    static: {
      prod: 'static.nationalgeographicla.com'
      // stage: 'd2yjz1u528xpd7.cloudfront.net'
    },
    search: {
      stage: 'vwe6c39nkj'
    },
    weekStartDay: 0,
    region: 'latam',
    currency: 'mxn'
  },
  es: {
    country: 'es',
    domain: 'www.nationalgeographic.es',
    html: {
      stage: 'dqycso6ai2tad.cloudfront.net'
    },
    static: {
      prod: 'static.nationalgeographic.es'
      // stage: 'd3vn7zoq1wnpn.cloudfront.net'
    },
    search: {
      stage: 'dpcm9skc5m'
    },
    weekStartDay: 1,
    region: 'emea',
    currency: 'eur'
  },
  fr: {
    country: 'fr',
    domain: 'www.nationalgeographic.fr',
    html: {
      stage: 'd2qijvrij2kjsi.cloudfront.net'
    },
    static: {
      prod: 'static.nationalgeographic.fr'
      // stage: 'd3dquktn7q9giq.cloudfront.net'
    },
    search: {
      stage: '67ulj790ac'
    },
    weekStartDay: 1,
    region: 'emea',
    currency: 'eur'
  },
  'en-gb': {
    country: 'uk',
    domain: 'www.nationalgeographic.co.uk',
    html: {
      stage: 'd1w5tfnhbo59kb.cloudfront.net'
    },
    static: {
      prod: 'fng-globalsites-prod-static-uk.s3.eu-central-1.amazonaws.com'
      // stage: 'd3ktbhoxi64ayf.cloudfront.net'
    },
    search: {
      stage: 'pn8duyuo2j'
    },
    weekStartDay: 1,
    region: 'emea',
    currency: 'gbp'
  }
};

const configByCountry = {};
Object.keys(configByLanguage).forEach(langcode => {
  const countryCode = configByLanguage[langcode].country;
  configByCountry[countryCode] = { ...configByLanguage[langcode], langcode };
});

const configByDomain = {};
Object.keys(configByLanguage).forEach(langcode => {
  const { domain } = configByLanguage[langcode];
  configByDomain[domain] = { ...configByLanguage[langcode], langcode };
});

module.exports = { configByLanguage, configByCountry, configByDomain };
